export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1717_.475a912b.jpg";